export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10441.99fc3b54.jpg";